<template>
  <div >
      <navbar />
       <index/>
       <!-- <footer2/> -->
  </div>
</template>

<script>
import { mapState } from "vuex";

import navbar from '../components/navbar'
import index from '../components/index'
import footer2 from '../components/footer2'

export default {
  name: 'HelloWorld',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
    computed: {
         ...mapState(["profilemenumargin"]),
    },
  components:{
      navbar,
      footer2,
      index
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.marginmenu{
  margin-right:400px;
  transition: all 0.5s;
}
.margin0{
  margin-right: 0;
  transition: all 0.5s
}
/* @media screen and (min-width: 1088px){
.container {
    max-width: calc(98vw - 400px);
    width: calc(98vw - 400px);
}
}
@media screen and (min-width: 1280px){
.container {
    max-width: calc(98vw - 400px);
    width: calc(98vw - 400px);
}
}

@media only screen and (max-width: 1087px) {
  .container{
    padding:5px
  }
} 

@media only screen and (max-width: 769px) {
  .container{
    padding:5px
  }
} 
@media only screen and (max-width: 760px) {
  .marginmenu{
    margin-right: 0px !important
  }
} */
</style>



// WEBPACK FOOTER //
// src/views/homepage.vue